import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/auth.context";
import Layout from "../components/layout";
import LayoutV2 from "../components/layout_v2";

export const RequireAuth = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  const query = new URLSearchParams(location.search);
  const queryVersion = query.get("layout");
  const acceptedVersion = queryVersion === "legacy" || queryVersion === "v2";

  if (acceptedVersion && queryVersion) {
    localStorage.setItem("dashboard_layout_version", queryVersion);
  }

  const persistedVersion = localStorage.getItem("dashboard_layout_version");
  const layoutVersion = persistedVersion === "v2" ? "v2" : "legacy";
  const Wrapper = layoutVersion === "v2" ? LayoutV2 : Layout;

  return <Wrapper>
    <Outlet />
  </Wrapper>;
};
